import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import * as ObjectActions from './device-type.actions';
import { DeviceTypeService } from '../../../shared/service/filter/device-type.service';
import { DeviceTypeCRUDInterface } from '../../../shared/component/filter/filter.class';
import { generateHttpOption } from '../../../shared/helper/app-helper';

@Injectable()
export class FilterDeviceTypeEffects {
  @Effect()
  loadFilterDeviceTypes$ = this.actions$.pipe(
    ofType(ObjectActions.FilterDeviceTypeActionTypes.StartLoadFilterDeviceTypes),
    switchMap((objectData: ObjectActions.StartLoadFilterDeviceTypes) => {
      const params = generateHttpOption(objectData.options);
      return from(this.deviceTypeService.getData(params)).pipe(
        switchMap((response: DeviceTypeCRUDInterface[]) => {
          return of(new ObjectActions.FilterDeviceTypesLoaded(response));
        }),
        catchError(() => {
          return of(new ObjectActions.FilterDeviceTypesLoaded([]));
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions<ObjectActions.FilterDeviceTypeActions>,
    public deviceTypeService: DeviceTypeService,
  ) {}
}
